// extracted by mini-css-extract-plugin
module.exports = {"link":"ContactOptionLenkebase_link__5oxWm"};